import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import CONFIG from '../../../../config'
import { Layout } from '../../../containers'
import { Button, Card, CircleStatus, Icon, Input, Loading, Modal, Paginate, Table, Title, Text, useModal } from '../../../components/UI'
import { useAds } from '../../../hooks'

interface IAdsSearchForm {
  searchTerm: string
}

const pageDefault: number = 1

const AdminAdsHomePage:FC = () => {
  const { register, handleSubmit, getValues } = useForm<IAdsSearchForm>()
  const ads = useAds('FILTER')
  const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)
  const [ad, setAd] = useState<any>()
  const modalDelete = useModal()

  const tableColumns = [
    {
      accessor: 'id',
      Header: 'ID',
      width: '8%',
      headerClassName: 'text-center'
    },
    {
      accessor: 'url',
      Header: 'URL',
      width: '30%'
    },
    {
      accessor: 'image',
      Header: 'Imagen',
      width: '25%'
    },
    {
      accessor: 'status',
      Header: 'Estado',
      width: '17%',
      Cell: (params: any) => {
        const { value } = params

        return (
          <div className="d-flex align-items-center justify-content-between">
            <span className="text-capitalize">{value ? 'Habilitado' : 'Deshabilitado'}</span>
            <CircleStatus status={value ? 1 : 2} />
          </div>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Acción',
      width: '20%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="d-flex">
            <Button component="link" to={`${CONFIG.ROUTES.ADMIN.ADS.EDIT}/${original.id}`} size="sm">
              EDITAR<Icon name="edit" className="align-top ml-5 va" />
            </Button>
            {original.status === true &&
              <Button size="sm" className="ml-5" onClick={() => onModalShow(original)}>
                BORRAR<Icon name="disabled" className="align-top ml-5" />
              </Button>
            }
          </div>
        )
      }
    }
  ]

  const getSearchTerm = (): string => getValues('searchTerm')

  const setAdsSearch = (filter: string = '', page: number = 1) => {
    ads.getAdsSearch(filter, page)
  }

  const delAd = async (adId: number) => {
    const resp = await ads.delAd(adId)
    if(resp && resp.status === 'Ok') setAdsSearch(getSearchTerm(), pageCurrent)
  }

  const onModalShow = (ad: any) => {
    setAd(ad)
    modalDelete.open()
  }

  const onAdDelete = async () => {
    const { id } = ad
    delAd(id)
    modalDelete.close()
  }

  const onSearchPageCurrent = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    setAdsSearch(getSearchTerm(), pageCurrent)
  }

  const onSearchSubmit = (fData: IAdsSearchForm) => {
    const { searchTerm } = fData
    setPageCurrent(pageDefault)
    setAdsSearch(searchTerm, pageDefault)
  }

  const { data, dataLoad } = ads

  return (
    <Layout role="ADMIN_ROLE" menu={true}>
      <Title border>Administrador de Anuncios</Title>

      <Card className="mt-50 py-20 px-70">
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSearchSubmit)}>
          <div className="d-flex">
            <div style={{ flex:'0 0 270px', maxWidth: '270px' }}>
              <Button component="link" size="md" to={CONFIG.ROUTES.ADMIN.ADS.CREATE} style={{ minWidth: 105 }}>CREAR</Button>
            </div>
            <div className="col pl-0" style={{ width: '100%' }}>
              <Input
                {...register('searchTerm')}
                placeholder="Escribe aquí lo que buscas"
                version="2"
                icon="search"
                fullWidth
              />
            </div>
            <div style={{ flex:'0 0 85px', maxWidth: '85px' }}>
              <Button
                type="submit"
                size="md"
                disabled={dataLoad}
              >BUSCAR</Button>
            </div>
          </div>
        </form>

        <div className="position-relative mt-30" style={{ minHeight: 150 }}>
          <Table
            columns={tableColumns}
            data={data && data.ads ? data.ads : []}
          />
          {dataLoad && <Loading overlay />}
        </div>

        <div className="text-center mt-20">
          <Paginate
            current={pageCurrent}
            total={data ? data.count : 0}
            onPageChange={(current) => onSearchPageCurrent(current)}
          />
        </div>
      </Card>

      <Modal show={modalDelete.show} maxWidth="345px" onClose={() => modalDelete.close()}>
        <div className="text-center pt-70 pb-60 px-50">
          <Text component="label" size="20" weight="bold">¿Estás seguro(a) que deseas deshabilitar este anuncio?</Text>

          <div className="mt-40">
            <Button fullWidth onClick={onAdDelete}>SÍ, DESHABILITAR</Button>
            <Button fullWidth className="mt-10" onClick={() =>  modalDelete.close()}>NO, CANCELAR</Button>
          </div>
        </div>
      </Modal>
    </Layout>
  )
}

export { AdminAdsHomePage }